import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=f8326996&"
import script from "./NotificationsPanel.vue?vue&type=script&lang=ts&"
export * from "./NotificationsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=f8326996&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports